import { useCallback } from 'react';

import { useUrlParams } from '~/hooks/useUrlParams';

/** A viewer/preview key (`version`, `session`, `test`): opening pushes history, closing replaces it. */
export function useTransientParam(key: string) {
  const url = useUrlParams();
  const value = url.get(key);
  const open = useCallback((id: string) => url.set({ [key]: id }, { history: 'push' }), [url, key]);
  const close = useCallback(() => url.set({ [key]: null }), [url, key]);
  return { value, open, close };
}
